<template lang="pug">
Button.submit-button(:label="text" @click="quoteRecommendations(QuoteOrigin.ActionButton)")
</template>
<script lang="ts">
import { defineComponent } from "vue";
import Button from "primevue/button";
import { useSettings } from "@/store/settings";
import { useRecommendations } from "@/store/recommendations";
import { QuoteOrigin } from "@/helpers";

export default defineComponent({
  name: "ScheduleButton",
  components: {
    Button,
  },
  setup() {
    const text = useSettings().settings?.actionButtonText;
    const { quoteRecommendations } = useRecommendations();
    return {
      text,
      quoteRecommendations,
      QuoteOrigin,
    };
  },
});
</script>
<style scoped lang="scss">
.p-button {
  width: 100%;
  height: 100%;
  min-height: 45px;
}
</style>
